export default "__VITE_ASSET__DUWJd5gc__"